/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getListDepartments({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get('/departments', { params: { ...payload } }));
    if (response?.status === 200) {
      yield put(Actions.getListDepartmentSuccess(response.data));
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getListDepartmentFailure(messages));
    }
  }
}

function* createDepartment({ payload }) {
  try {
    const response = yield call(() => axiosMicro.post('/departments', payload));
    yield put(Actions.createDepartmentSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.createDepartmentFailure(messages));
    }
  }
}

function* updateDepartments({ payload }) {
  try {
    const { id, ...data } = payload;
    const response = yield call(() => axiosMicro.patch(`/departments/${id}`, data));

    if (response?.status === 200) {
      yield put(Actions.updateDepartmentSuccess());
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.updateDepartmentFailure(messages));
    }
  }
}

function* deleteDepartments({ payload }) {
  try {
    const response = yield call(() => axiosMicro.delete(`/departments/${payload.id}`));
    yield put(Actions.deleteDepartmentSuccess());
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.deleteDepartmentFailure(messages));
    }
  }
}

function* getDetailDepartments({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(`/departments/${payload.id}`));
    yield put(Actions.getDetailDepartmentSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getDetailDepartmentFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getListDepartmentRequest, getListDepartments);
  yield takeLatest(Actions.createDepartmentRequest, createDepartment);
  yield takeLatest(Actions.getDetailDepartmentRequest, getDetailDepartments);
  yield takeLatest(Actions.updateDepartmentRequest, updateDepartments);
  yield takeLatest(Actions.deleteDepartmentRequest, deleteDepartments);
}
